<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-14 18:23:36
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-06-03 17:13:59
 * @Description: grid布局，一个grid代表一行<Row>
 -->
<template>
  <div class="wg-grid">
    <a-row type="flex"
      :gutter="options.gutter"
      :justify="options.justify"
      :align="options.align"
      :hidden="options.hidden">
      <template v-for="(columns,index) in widget.columns">
        <!-- ------{{columns}}===== -->
        <a-col :key="index"
          class="wg-grid-col"
          :span="columns.span">
          <!-- 循环输出其中的列表 -->
          <wgList :list="columns.list">
            <template v-for="key in formSlotsKeys"
              v-slot:[key]>
              <slot :name="key"></slot>
            </template>
          </wgList>
        </a-col>
      </template>
    </a-row>
  </div>
</template>
<script>
import baseMixin from '../lib/baseMixin';

export default {
  name: 'wgGrid',
  mixins: [baseMixin],
  data() {
    return {
      options: {
        gutter: 24,
        justify: 'start',
        align: 'top',
        customClass: '',
        hidden: false,
      },
    };
  },
  computed: {
    formSlotsKeys() {
      if (this.formContext) {
        return Object.keys(this.formContext.formSlots);
      }
      return [];
    },
  },
};
</script>
